<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12">
          <name-text />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import NameText from '@/views/Defines/Service_types/Elements/NameText.vue'

export default {
  name: 'ItemForm',
  components: {
    NameText,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['serviceTypes/dataItem']
    },
  },
}
</script>
